import ajax from '../common/js/ajax.js' //引用封装好的axios
const api = {} //新建一个api对象 里面放开发时使用的一系列接口
api.login = (params, data) => ajax('user/login', params, 'post')
// 获取所有省市区
api.listAllAreaInfo = (params, data) => ajax('areaInfo/listAllAreaInfo', params, 'get')
// 获取所有社区类型
api.listAllCommunityType = (params, data) => ajax('communityInfo/listAllCommunityType', params, 'get')
// 社区列表
api.listCommunityInfo = (params, data) => ajax('communityInfo/listCommunityInfo', params, 'post')
// 设备列表
api.listCommunityEquipment = (params, data) => ajax('communityEquipment/listCommunityEquipment', params, 'post')
// 故障设备列表
api.listUnlineCommunityEquipment = (params, data) => ajax('communityEquipment/listUnlineCommunityEquipment', params,
	'post')
// 导入excel表格
api.upLoadExcelData = (params, data) => ajax('communityEquipment/upLoadExcelData', params, 'post')
// 社区查看详情
api.selectCommunityInfo = (params, data) => ajax('communityInfo/selectCommunityInfo', params, 'post')
// 社区添加
api.addCommunityInfo = (params, data) => ajax('communityInfo/addCommunityInfo', params, 'post')
// 社区修改
api.updateCommunityInfo = (params, data) => ajax('communityInfo/updateCommunityInfo', params, 'post')
// 社区删除
api.deleteCommunityInfo = (params, data) => ajax('communityInfo/deleteCommunityInfo', params, 'post')
// 站点列表
api.listCommunitySite = (params, data) => ajax('communitySite/listCommunitySite', params, 'post')
// 站点添加
api.addCommunitySite = (params, data) => ajax('communitySite/addCommunitySite', params, 'post')
// 站点修改
api.updateCommunitySite = (params, data) => ajax('communitySite/updateCommunitySite', params, 'post')
// 站点查看
api.selectCommunitySite = (params, data) => ajax('communitySite/selectCommunitySite', params, 'post')
// 站点删除
api.deleteCommunitySite = (params, data) => ajax('communitySite/deleteCommunitySite', params, 'post')
// 根据社区id查询该社区所有站点
api.listAllCommunitySiteByCommunityId = (params, data) => ajax('communitySite/listAllCommunitySiteByCommunityId',
	params, 'post')
// 设备添加
api.addCommunityEquipment = (params, data) => ajax('communityEquipment/addCommunityEquipment', params, 'post')
// 设备查看
api.selectCommunityEquipment = (params, data) => ajax('communityEquipment/selectCommunityEquipment', params, 'post')
// 设备修改
api.updateCommunityEquipment = (params, data) => ajax('communityEquipment/updateCommunityEquipment', params, 'post')
// 查看二维码
api.createQRCode = (params, data) => ajax('communityEquipment/createQRCode', params, 'post', "blob")
// 设备删除
api.deleteCommunityEquipment = (params, data) => ajax('communityEquipment/deleteCommunityEquipment', params, 'post')
// 设备解绑
api.unbindCommunityEquipment = (params, data) => ajax('communityEquipment/unbindCommunityEquipment', params, 'post')
// 充电标准金额设置列表
api.listAllRechargeBasicPowerSet = (params, data) => ajax('rechargeBasicSet/listAllRechargeBasicPowerSet', params,
	'get')
// 充电标准金额设置添加
api.addRechargeBasicPowerSet = (params, data) => ajax('rechargeBasicSet/addRechargeBasicPowerSet', params, 'post')
// 新增功率
api.addRechargeBasicSet = (params, data) => ajax('rechargeBasicSet/addRechargeBasicSet', params, 'post')
// 删除功率
api.deleteRechargeBasicPowerSet = (params, data) => ajax('rechargeBasicSet/deleteRechargeBasicPowerSet', params, 'post')
// 充电标准金额设置修改
api.updateRechargeBasicSet = (params, data) => ajax('rechargeBasicSet/updateRechargeBasicSet', params, 'post')
// 充电标准金额设置删除
api.deleteRechargeBasicSet = (params, data) => ajax('rechargeBasicSet/deleteRechargeBasicSet', params, 'post')
// 获取所有社区类型
api.listAllCommunityType = (params, data) => ajax('rechargeCommunityBasicSet/listAllCommunityType', params, 'get')
// 社区列表
api.listCommunityInfo2 = (params, data) => ajax('rechargeCommunityBasicSet/listCommunityInfo', params, 'post')
// 社区充电金额配置列表
api.listRechargeBasicSetByCommunityId = (params, data) => ajax(
	'rechargeCommunityBasicSet/listRechargeBasicSetByCommunityId', params, 'post')
// 社区充电金额配置修改
api.updateRechargeBasicSetByCommunityId = (params, data) => ajax(
	'rechargeCommunityBasicSet/updateRechargeBasicSetByCommunityId', params, 'post')
// 充值金额基本配置列表
api.listAllAmountBasicSet = (params, data) => ajax('amountBasicSet/listAllAmountBasicSet', params, 'get')
// 充值金额活动添加
api.addAmountBasicSet = (params, data) => ajax('amountBasicSet/addAmountBasicSet', params, 'post')
// 充值金额基本配置修改
api.updateAmountBasicSet = (params, data) => ajax('amountBasicSet/updateAmountBasicSet', params, 'post')
// 充值金额基本配置删除
api.deleteAmountBasicSet = (params, data) => ajax('amountBasicSet/deleteAmountBasicSet', params, 'post')
// 充值金额活动列表
api.listAmountActivity = (params, data) => ajax('amountActivity/listAmountActivity', params, 'post')
// 充值金额基本配置列表
api.listAmountBasicSet = (params, data) => ajax('amountActivity/listAmountBasicSet', params, 'get')
// 充值金额活动添加
api.addAmountActivity = (params, data) => ajax('amountActivity/addAmountActivity', params, 'post')
// 充值金额活动查看
api.selectAmountActivity = (params, data) => ajax('amountActivity/selectAmountActivity', params, 'post')
// 充值金额活动修改
api.updateAmountActivity = (params, data) => ajax('amountActivity/updateAmountActivity', params, 'post')
// 充值金额活动删除
api.deleteAmountActivity = (params, data) => ajax('amountActivity/deleteAmountActivity', params, 'post')
// 充值记录
api.listUserInfoAccountRecord = (params, data) => ajax('accountRecord/listUserInfoAccountRecord', params, 'post')
// 退款记录
api.listUserInfoAccountWithdrawalRecord = (params, data) => ajax('accountRecord/listUserInfoAccountWithdrawalRecord',
	params, 'post')
// 统计分析
api.statisticalAnalysis = (params, data) => ajax('accountRecord/statisticalAnalysis', params, 'post')
// 用户故障反馈列表
api.listCommunityEquipmentFaultReport = (params, data) => ajax(
	'communityEquipmentFaultReport/listCommunityEquipmentFaultReport', params, 'post')
// 用户管理列表
api.listUseInfo = (params, data) => ajax('user/listUseInfo', params, 'post')
// 广告查询
api.listProjectAdvertisementByPictureType = (params, data) => ajax(
	'projectAdvertisement/listProjectAdvertisementByPictureType', params, 'post')
// 广告修改
api.updateProjectAdvertisement = (params, data) => ajax('projectAdvertisement/updateProjectAdvertisement', params,
	'post')
// 广告删除
api.deleteProjectAdvertisement = (params, data) => ajax('projectAdvertisement/deleteProjectAdvertisement', params,
	'post')
// 运维人员列表
api.listOrderRepairUser = (params, data) => ajax('repairUser/listOrderRepairUser', params, 'post')
// 承包商列表
api.listContractor = (params, data) => ajax('contractor/listContractor', params, 'post')
// 运维人员添加
api.addOrderRepairUser = (params, data) => ajax('repairUser/addOrderRepairUser', params, 'post')
// 运维人员查看
api.selectOrderRepairUser = (params, data) => ajax('repairUser/selectOrderRepairUser', params, 'post')
// 运维人员修改
api.updateOrderRepairUser = (params, data) => ajax('repairUser/updateOrderRepairUser', params, 'post')
// 运维人员删除
api.deleteOrderRepairUser = (params, data) => ajax('repairUser/deleteOrderRepairUser', params, 'post')
// 运维人员审核
api.checkOrderRepairUser = (params, data) => ajax('repairUser/checkOrderRepairUser', params, 'post')
// 故障管理列表
api.listOrderFault = (params, data) => ajax('orderFault/listOrderFault', params, 'post')
// 故障管理详情
api.selectOrderFault = (params, data) => ajax('orderFault/selectOrderFault', params, 'post')
// 故障审核
api.checkOrderFaultRepairUser = (params, data) => ajax('orderFault/checkOrderFaultRepairUser', params, 'post')
// 故障派单信息列表
api.listOrderFaultRepairUser = (params, data) => ajax('orderFault/listOrderFaultRepairUser', params, 'post')
// 故障派发
api.bindOrderFaultRepairUser = (params, data) => ajax('orderFault/bindOrderFaultRepairUser', params, 'post')
// 工单处理
api.dealOrderFaultRepairUser = (params, data) => ajax('orderFault/dealOrderFaultRepairUser', params, 'post')
// 巡检人员列表
api.listAllOrderRepairUser = (params, data) => ajax('orderPatrol/listAllOrderRepairUser', params, 'get')
// 巡检记录列表
api.listOrderPatrol = (params, data) => ajax('orderPatrol/listOrderPatrol', params, 'post')
// 参数配置列表
api.listParamConfig = (params, data) => ajax('paramConfig/listParamConfig', params, 'get')
// 参数配置添加
api.addParamConfig = (params, data) => ajax('paramConfig/addParamConfig', params, 'post')
// 参数配置修改
api.updateParamConfig = (params, data) => ajax('paramConfig/updateParamConfig', params, 'post')
// 参数配置删除
api.deleteParamConfig = (params, data) => ajax('paramConfig/deleteParamConfig', params, 'post')
// 现有管辖省市区
api.listAreaInfo = (params, data) => ajax('repairUser/listAreaInfo', params, 'post')
// 参数配置根据码值查询
api.selectParamConfigByCode = (params, data) => ajax('paramConfig/selectParamConfigByCode', params, 'post')
// 统计分析
api.getStatisticAnalysis = (params, data) => ajax('elec/getStatisticAnalysis', params, 'get')
// 小区类型服务次数
api.getElecCountByType = (params, data) => ajax('elec/getElecCountByType', params, 'get')
// 充电记录
api.listRechargeRecord = (params, data) => ajax('elec/listRechargeRecord', params, 'post')
// 角色列表 权限管理
api.listUserRole = (params, data) => ajax('userRole/listUserRole', params, 'post')
// 角色添加
api.addUserRole = (params, data) => ajax('userRole/addUserRole', params, 'post')
// 角色修改
api.updateUserRole = (params, data) => ajax('userRole/updateUserRole', params, 'post')
// 角色删除
api.deleteUserRole = (params, data) => ajax('userRole/deleteUserRole', params, 'post')
// 权限配置列表
api.listPermissionsModelByRoleId = (params, data) => ajax('userRole/listPermissionsModelByRoleId', params, 'post')
// 角色绑定权限
api.bindUserRolePermissions = (params, data) => ajax('userRole/bindUserRolePermissions', params, 'post')
// 角色列表 账号管理
api.listRole = (params, data) => ajax('userPlatform/listRole', params, 'get')
// 账号列表
api.listUserPlatform = (params, data) => ajax('userPlatform/listUserPlatform', params, 'post')
// 账号添加
api.addUserPlatform = (params, data) => ajax('userPlatform/addUserPlatform', params, 'post')
// 账号修改
api.updateUserPlatform = (params, data) => ajax('userPlatform/updateUserPlatform', params, 'post')
// 账号删除
api.deleteUserPlatform = (params, data) => ajax('userPlatform/deleteUserPlatform', params, 'post')
// 权限配置列表
api.listPermissionsModel = (params, data) => ajax('permissionsModel/listPermissionsModel', params, 'get')
// 权限配置添加
api.addPermissionsModel = (params, data) => ajax('permissionsModel/addPermissionsModel', params, 'post')
// 权限配置修改
api.updatePermissionsModel = (params, data) => ajax('permissionsModel/updatePermissionsModel', params, 'post')
// 权限配置删除
api.deletePermissionsModel = (params, data) => ajax('permissionsModel/deletePermissionsModel', params, 'post')
// 结算记录
api.listSettlementRecord = (params, data) => ajax('orderFault/listSettlementRecord', params, 'post')
// 用户卡列表
api.listUserInfoCard = (params, data) => ajax('userInfoCard/listUserInfoCard', params, 'post')
// 用户卡修改
api.updateUserInfoCard = (params, data) => ajax('userInfoCard/updateUserInfoCard', params, 'post')
// 用户卡删除
api.deleteUserInfoCard = (params, data) => ajax('userInfoCard/deleteUserInfoCard', params, 'post')
// 用户卡添加
api.addUserInfoCard = (params, data) => ajax('userInfoCard/addUserInfoCard', params, 'post')
// 电卡编号列表
api.selectNoBindUserInfoCard = (params, data) => ajax('userInfoCard/selectNoBindUserInfoCard', params, 'post')
// 电卡绑定编号
api.linkCard = (params, data) => ajax('userInfoCard/linkCard', params, 'post')
// 电卡押金余额
api.countCardDeposit = (params, data) => ajax('userInfoCard/countCardDeposit', params, 'get')
// 运营统计
api.operationalStatistics = (params, data) => ajax('operationAnalysis/operationalStatistics', params, 'post')
// 充值统计
api.rechargeStatistics = (params, data) => ajax('operationAnalysis/rechargeStatistics', params, 'post')
// 充值情况
api.rechargeSituation = (params, data) => ajax('operationAnalysis/rechargeSituation', params, 'post')
// 省市区社区4级联动
api.listAreaInfoAndCommunity = (params, data) => ajax('amountActivity/listAreaInfoAndCommunity', params, 'post')
// 地区运营数据列表
api.listOperationalData = (params, data) => ajax('operationAnalysis/listOperationalData', params, 'post')
// 充电记录导出
api.exportRechargeRecord = (params, str) => ajax('elec/exportRechargeRecord', params, 'post', "blob", str)
// 充值记录导出
api.exportUserInfoAccountRecord = (params, str) => ajax('accountRecord/exportUserInfoAccountRecord', params, 'post',
	"blob", str)
// 运维人员导出
api.exportUserInfoAccountWithdrawalRecord = (params, str) => ajax('accountRecord/exportUserInfoAccountWithdrawalRecord',
	params, 'post', "blob", str)
// 提现记录导出
api.exportOrderRepairUser = (params, str) => ajax('repairUser/exportOrderRepairUser', params, 'post', "blob", str)
// 巡检记录导出
api.exportOrderPatrol = (params, str) => ajax('orderPatrol/exportOrderPatrol', params, 'post', "blob", str)
// 用户导出
api.exportUseInfo = (params, str) => ajax('user/exportUseInfo', params, 'post', "blob", str)
// 角色导出
api.exportUserRole = (params, str) => ajax('userRole/exportUserRole', params, 'post', "blob", str)
// 账号导出
api.exportUserPlatform = (params, str) => ajax('userPlatform/exportUserPlatform', params, 'post', "blob", str)
// 运营商导出
api.exportServiceProvider = (params, str) => ajax('serviceProvider/exportServiceProvider', params, 'post', "blob", str)
// 对账列表导出
api.exportServiceProviderBill = (params, str) => ajax('bill/exportServiceProviderBill', params, 'post', "blob", str)
// 承包商列表导出
api.exportContractor = (params, str) => ajax('contractor/exportContractor', params, 'post', "blob", str)
// 运营商列表导出
api.exportDirectServiceProviderBill = (params, str) => ajax('bill/exportDirectServiceProviderBill', params, 'post',
	"blob", str)
// 用户功率配置
api.updatePower = (params, data) => ajax('user/updatePower', params, 'post')
// 运营概况
api.operationOverview = (params, data) => ajax('operationAnalysis/operationOverview', params, 'post')
// 设备初始化
api.initializeCommunityEquipment = (params, str, type) => ajax('communityEquipment/initializeCommunityEquipment',
	params, 'post', "blob", str, type)
// 提现列表
api.listWithdrawRecord = (params, data) => ajax('repairUser/listWithdrawRecord', params, 'post')
// 提现审核 运维
api.checkWithdraw = (params, data) => ajax('repairUser/checkWithdraw', params, 'post')
// 提现审核  用户
api.checkWithdrawalRecord = (params, data) => ajax('accountRecord/checkWithdrawalRecord', params, 'post')
// 运营商列表
api.listServiceProvider = (params, data) => ajax('serviceProvider/listServiceProvider', params, 'post')
// 运营商添加
api.addServiceProvider = (params, data) => ajax('serviceProvider/addServiceProvider', params, 'post', "form")
// 分账查看
api.selectAccountConfig = (params, data) => ajax('serviceProvider/selectAccountConfig', params, 'post')
// 运营商删除
api.deleteServiceProvider = (params, data) => ajax('serviceProvider/deleteServiceProvider', params, 'post')
// 分账配置
api.updateAccountConfig = (params, data) => ajax('serviceProvider/updateAccountConfig', params, 'post')
// 运营商修改
api.updateServiceProvider = (params, data) => ajax('serviceProvider/updateServiceProvider', params, 'post', "form")
// 对账列表
api.listServiceProviderBill = (params, data) => ajax('bill/listServiceProviderBill', params, 'post')
// 合同查看
api.viewContractor = (params, data) => ajax('contractor/viewContractor', params, 'post')
// 资质审核
api.checkAptitude = (params, data) => ajax('contractor/checkAptitude', params, 'post', "form")
// 合同管理
api.setContract = (params, data) => ajax('contractor/setContract', params, 'post', "form")
// 合同删除
api.deleteContract = (params, data) => ajax('contractor/deleteContract', params, 'post')
// 故障添加
api.addOrderFault = (params, data) => ajax('orderFault/addOrderFault', params, 'post', "form")
// 运营商电费管理列表
api.listDirectServiceProviderBill = (params, data) => ajax('bill/listDirectServiceProviderBill', params, 'post')
// 运营商列表修改
api.updateDirectServiceProviderBill = (params, data) => ajax('bill/updateDirectServiceProviderBill', params, 'post')
// 所有运营商列表
api.listAllProvider = (params, data) => ajax('serviceProvider/listAllProvider', params, 'get')
// 添加赠送金
api.updateExtraAccount = (params, data) => ajax('user/updateExtraAccount', params, 'post')
// 赠送金记录
api.listExtraAccount = (params, data) => ajax('user/listExtraAccount', params, 'post')
// 功率查询
api.listPowerList = (params, data) => ajax('elec/listPowerList', params, 'post')
// 使用率查询
api.selectEquipmentUsedByEquipmentIdAndDateType = (params, data) => ajax(
	'communityEquipment/selectEquipmentUsedByEquipmentIdAndDateType', params, 'post')
// 查社区下拉列表 地区
api.listAllCommunityByAreaCode = (params, data) => ajax('operationAnalysis/listAllCommunityByAreaCode', params, 'post')
// 查社区列表 地区
api.listCommunityByAreaCode = (params, data) => ajax('operationAnalysis/listCommunityByAreaCode', params, 'post')
// 查社区下拉列表 运营商
api.listAllCommunityByServiceProviderId = (params, data) => ajax(
	'operationAnalysis/listAllCommunityByServiceProviderId', params, 'post')
// 查社区列表 运营商
api.listCommunityByServiceProviderId = (params, data) => ajax('operationAnalysis/listCommunityByServiceProviderId ',
	params, 'post')
// 查社区设备下拉列表
api.listAllEquipmentByCommunityId = (params, data) => ajax('operationAnalysis/listAllEquipmentByCommunityId', params,
	'post')
// 查社区设备列表
api.listEquipmentByCommunityId = (params, data) => ajax('operationAnalysis/listEquipmentByCommunityId', params, 'post')
// 修改用户状态
api.updateUseStatus = (params, data) => ajax('user/updateUseStatus', params, 'post')
// 充电次数曲线图
api.selectOrderCountByServiceProviderAndDateType = (params, data) => ajax(
	'operationAnalysis/selectOrderCountByServiceProviderAndDateType', params, 'post')
// 充电收入曲线图
api.selectOrderAmountByServiceProviderAndDateType = (params, data) => ajax(
	'operationAnalysis/selectOrderAmountByServiceProviderAndDateType', params, 'post')
// 离线记录
api.listUnlineRecord = (params, data) => ajax('communityEquipment/listUnlineRecord', params, 'post')
// 设备复位
api.resetCommunityEquipment = (params, data) => ajax('communityEquipment/resetCommunityEquipment', params, 'post')
// 退款
api.updateRechargeRecord = (params, data) => ajax('elec/updateRechargeRecord', params, 'post')
// 版本列表
api.listVersion = (params, data) => ajax('version/listVersion', params, 'post')
// 添加版本
api.addVersion = (params, data) => ajax('version/addVersion', params, 'post', "form")
// 编辑版本
api.updateVersion = (params, data) => ajax('version/updateVersion', params, 'post', "form")
// 版本状态修改
api.updateVersionStatus = (params, data) => ajax('version/updateVersionStatus', params, 'post')
// 设置默认版本
api.updateVersionDefault = (params, data) => ajax('version/updateVersionDefault', params, 'post')
// 删除版本
api.deleteVersionByVersionId = (params, data) => ajax('version/deleteVersionByVersionId', params, 'post')
// 版本集合
api.listAllVersion = (params, data) => ajax('version/listAllVersion', params, 'get')
// 版本设备数量
api.countEquipmentNum = (params, data) => ajax('sysUpdateRecord/countEquipmentNum', params, 'get')
// 版本升级
api.addUpdateRecord = (params, data) => ajax('sysUpdateRecord/addUpdateRecord', params, 'post')
// 版本升级记录
api.listUpdateRecord = (params, data) => ajax('sysUpdateRecord/listUpdateRecord', params, 'post')
// 版本升级详情
api.listUpdateEquipmentByUpdateRecordId = (params, data) => ajax('sysUpdateRecord/listUpdateEquipmentByUpdateRecordId', params, 'post')
export default api //将新建好的api对象模块指定默认输出 
// 今日统计  充电
api.todayStatistics = (params, data) => ajax('elec/todayStatistics', params, 'get')
// 今日统计  充值
api.todayStatisticalAnalysis = (params, data) => ajax('accountRecord/todayStatisticalAnalysis', params, 'get')
// 卡充值记录
api.listUserInfoCardRecord = (params, data) => ajax('userInfoCard/listUserInfoCardRecord', params, 'post')
// 查询用户列表
api.listUserInfoByPhone = (params, data) => ajax('serviceProvider/listUserInfoByPhone', params, 'post')
// 绑定运营商
api.bindUser = (params, data) => ajax('serviceProvider/bindUser', params, 'post')
// 异常记录
api.stopOrder = (params, data) => ajax('elec/stopOrder', params, 'post')
// 电卡增加赠送金
api.addExtraBalanceRecord = (params, data) => ajax('userInfoCard/addExtraBalanceRecord', params, 'post')
// 赠送记录
api.listExtraBalanceRecord = (params, data) => ajax('userInfoCard/listExtraBalanceRecord', params, 'post')

//现有二维码导出
api.exportExistEquipmentExcel = (params, str, type) => ajax('communityEquipment/exportExistEquipmentExcel',
	params, 'get', "blob", str, type)

//设备故障列表
api.listFaultCommunityEquipmentPort = (params, data) => ajax('communityEquipment/listFaultCommunityEquipmentPort', params, 'post')
// api.upLoadimg = () => ajax('projectAdvertisement/addProjectAdvertisement')

//小程序公告列表
api.listSysNotice = (params, data) => ajax('sysNotice/listSysNotice', params, 'post')
//添加小程序公告列表
api.addSysNotice = (params, data) => ajax('sysNotice/addSysNotice', params, 'post')
//修改小程序公告列表
api.updateSysNotice = (params, data) => ajax('sysNotice/updateSysNotice', params, 'post')
//删除小程序公告列表
api.deleteSysNotice = (params, data) => ajax('sysNotice/deleteSysNotice', params, 'post')
//新增设置计费方式
api.addCommunityBillingType = (params, data) => ajax("rechargeCommunityBasicSet/updateCommunityBillingType",params, 'post')
//编辑设置计费方式
api.updateCommunityBillingType = (params, data) => ajax("rechargeCommunityBasicSet/updateCommunityBillingType",params, 'post')
//保存社区电价时段明细
api.saveElectricPricePeriod = (params, data) => ajax('rechargeCommunityBasicSet/saveElectricPricePeriod',params, 'post')
//查询社区电价时段明细
api.listElectricPricePeriod = (params, data) => ajax('rechargeCommunityBasicSet/listElectricPricePeriod',params, 'post')

//测试对接平台
api.equipmentStatus = (params, data) => ajax('/api/sample/query_equipment_status', params, 'post', "docking")

api.equipmenToken = (params, data) => ajax('/api/sample/query_token', params, 'post')



